import { render, staticRenderFns } from "./OpportunitiesSummary.vue?vue&type=template&id=64c4d74e&scoped=true&"
import script from "./OpportunitiesSummary.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesSummary.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesSummary.vue?vue&type=style&index=0&id=64c4d74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4d74e",
  null
  
)

export default component.exports